import {
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  type SxProps,
  type Theme,
} from '@mui/material';
import { X } from 'lucide-react';

type DialogStickyHeaderProps = {
  title: React.ReactNode;
  onClose: () => void;
  loading?: boolean;
  sx?: SxProps<Theme>;
};

export const DialogStickyHeader: React.FC<DialogStickyHeaderProps> = ({
  title,
  onClose,
  loading,
  sx,
}) => {
  return (
    <Stack
      direction="row"
      component={Paper}
      elevation={0}
      sx={[
        theme => ({
          borderRadius: 0,
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'sticky',
          top: 0,
          paddingX: 2,
          paddingY: 1,
          zIndex: 2,
          borderBottom: `1px solid ${(theme.vars ?? theme).palette.divider}`,
        }),
        ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
      ]}
    >
      <DialogTitle sx={{ p: 0 }}>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        disabled={loading}
        sx={{ color: theme => (theme.vars ?? theme).palette.grey[500] }}
      >
        <X size={20} />
      </IconButton>
    </Stack>
  );
};
